import React, { Component } from 'react';
import { connect } from 'react-redux';
import { CardBody, Card, Col, Button, Row, Label, Input, Form, FormGroup, Table } from 'reactstrap';
import { Preloading as preloading } from '../../../components/UI/Preloader/action';
import * as DatabaseCaseCreation from './action';
import { toast } from 'react-toastify';

class DatabaseCasesComponent extends Component {
    state = {
        
        caseId: '',
        isLoading: false,   
    };

    
    handleChange = (event) => {
        this.setState({ caseId: event.target.value })
    };
    
    fetchDetails  = () => {
        this.props.preloading(true)
        this.props.databaseCaseCreation(this.state.caseId);

    }
    componentDidUpdate(prevProps) {
        const { databaseCaseCreationResults, databaseCaseCreationError } = this.props;
        if (databaseCaseCreationResults !== prevProps.databaseCaseCreationResults) {
            this.props.preloading(false);
            toast.success(
                <div>
                    Database Request Placed Successfully....!
                </div>
            );
        }
        else if (databaseCaseCreationError !== prevProps.databaseCaseCreationError) {
            
            this.props.preloading(false);
            const errorMessage = databaseCaseCreationError 
                ? databaseCaseCreationError.message 
                : "An unknown error occurred. Please try again later.";
            toast.error(
                <div>
                    {"Error While Processing Request.....!"} <br /> {errorMessage} <br /> {databaseCaseCreationError.response.data.message}
                </div>
            );
        }
    }
    render() {
        const {caseId, apiResponse, error, isLoading } = this.state;
        return (
            <Col>
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h4 className="mb-0 text-center">Database Request</h4>
                </div>
                <Card>
                <CardBody >
                        <Row>
                            <Col sm={12}>
                            <Input
                                name="caseId"
                                type="text"
                                className="form-control"
                                value={caseId}
                                onChange={this.handleChange}
                                placeholder="Enter Case ID"/> 
                            </Col>
                            <Col>
                            <Button
                                    color="primary"
                                    disabled={!caseId || isLoading}
                                    onClick={this.fetchDetails}>
                                    {isLoading ? 'Loading...' : 'Search'}
                            </Button>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
            </Col>
        );
    }
}

const mapStateToProps = (state) => ({
    databaseCaseCreationResults: state.databaseCaseCreationData.databaseCaseCreationSuccess,
    databaseCaseCreationError: state.databaseCaseCreationData.databaseCaseCreationFailure,
});

const mapDispatchToProps = (dispatch) => ({
    preloading: (data) => { dispatch(preloading(data)); },
    databaseCaseCreation: (data) => dispatch(DatabaseCaseCreation.databaseCaseCreation(data)) 
});

export default connect(mapStateToProps, mapDispatchToProps)(DatabaseCasesComponent);